import moment from "moment";

import { useUser } from "@components/user-context";

export function useYesterday() {
  const { user } = useUser();
  const yesterday = moment.tz(user.timezone).startOf("day").subtract(1, "day");

  return yesterday;
}
